<template>
  <div
    v-loading="loading"
    class="main-content"
    element-loading-text="Loading..."
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(170,170,170,0.5)"
  >
    <cargo-left-right-resize :left-style="{'width':'336px','flex':'unset'}" :right-style="{'flex-grow': '1'}">
      <template slot="left">
        <div class="section" style="height: 100%;">
          <span class="title">{{ $t('queryJob.roleList') }}</span>
          <cargo-ag-grid
            :grid-options="officeDeptTree.gridOptions"
            :column-defs="officeDeptTree.columnDefs"
            :row-data="officeDeptTree.rowData"
            :show-side-bar="false"
            :class="currentState===EDITING?'shadow':''"
            style="height: 100%;"
            @gridReady="params=>{officeDeptTree.gridApi=params.api}"
          />
          <div style="margin-top: 5px;">
            <el-button
              v-show="currentState===NORMAL"
              type="primary"
              style="float: right;"
              @click="currentState=EDITING"
            >{{ $t('CargoMsg.Cargo_Edit') }}</el-button>
            <div v-show="currentState===EDITING" style="float: right;">
              <el-button type="primary" @click="save">{{ $t('CargoMsg.Cargo_Save') }}</el-button>
              <el-button type="primary" @click="cancel">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
            </div>
          </div>
        </div>
      </template>
      <template slot="right">
        <cargo-left-right-resize style="height: 100%">
          <template slot="left">
            <div class="section" style="height: 100%;">
              <span class="title">{{ $t('queryJob.assignedResponsibilities') }}</span>
              <cargo-ag-grid
                :grid-options="ora.gridOptions"
                :column-defs="ora.columnDefs"
                :row-data="ora.rowData"
                style="height: 100%;width:100%;"
                @gridReady="params=>{ora.gridApi=params.api}"
              />
              <div style="margin-top: 5px;">
                <el-button
                  :disabled="!(currentState===EDITING&&ora.selectedNode)"
                  type="primary"
                  style="float: right;"
                  @click="remove"
                >{{ $t('CargoMsg.Cargo_Remove') }}&gt;</el-button>
              </div>
            </div>
          </template>
          <template slot="right">
            <div class="section" style="height: 100%;">
              <span class="title">{{ $t('queryJob.listOfResponsibilities') }}</span>
              <cargo-ag-grid
                :grid-options="ors.gridOptions"
                :column-defs="ors.columnDefs"
                :row-data="ors.rowData"
                style="height: 100%;width:100%;"
                @gridReady="params=>{ors.gridApi=params.api}"
              />
              <div style="margin-top: 5px;">
                <el-button
                  :disabled="!(currentState===EDITING&&ors.selectedNode)"
                  type="primary"
                  @click="add"
                >&lt;{{ $t('CargoMsg.Cargo_add') }}</el-button>
              </div>
            </div>
          </template>
        </cargo-left-right-resize>
      </template>
    </cargo-left-right-resize>
  </div>
</template>

<script>
import cargoLeftRightResize from '@/components/Cargo/Common/cargoLeftRightResize'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import ColumnUtils from '@/utils/ColumnUtils'
import { loadSpecificBasicInfo } from '@/api/cache'
import { getOfficeDeptTree } from '@/api/office'
import { loadAllOperationResponsibility } from '@/api/operationResponsibility'
import { getOperationResponsibilityKeys, saveOperationResponsibilities } from '@/api/role'

const NORMAL = 'normal' // 查看状态
const EDITING = 'editing' // 编辑状态

/* 操作职责类型 */
const AIR_ROUTE = 'AirRoute'
const AIR_COMPANY = 'AirCompany'
const BOOKING_TERM = 'BookingTerm'
const AIR_PORT = 'Airport'
const SALES = 'Sales'

export default {
  name: 'OperationResponsibilityAssign',
  components: { cargoLeftRightResize },
  data() {
    return {
      loading: false,
      NORMAL,
      EDITING,
      airRouteList: [],
      currentState: NORMAL, // 当前状态
      officeDeptTree: {
        gridOptions: {
          rowSelection: 'single',
          suppressCellSelection: true, // 如果为true，则不能选择单元格。
          suppressRowClickSelection: true, // 如果为true，则单击行时不会发生行选择。
          treeData: true,
          groupDefaultExpanded: 1,
          getDataPath: (data) => {
            return data.path.split(',')
          },
          autoGroupColumnDef: {
            headerName: this.$t('CargoMsg.Cargo_Name'),
            field: 'chineseName',
            width: 300,
            sortable: false,
            suppressMenu: true,
            suppressSizeToFit: true,
            cellRendererParams: {
              suppressCount: true,
              innerRenderer: params => {
                if (params.data.type === 1) {
                  return '[' + params.data.officeCode + '] ' + params.data.chineseName
                }
                if (params.data.type === 3) {
                  return '<svg class="svg-icon" aria-hidden="true" style="width:8px;height:8px;margin-bottom:2px;vertical-align:middle;">' +
                    '<use xlink:href="#icon-checkbox-notChecked"></use></svg>&nbsp;' + params.data.chineseName
                }
                return params.data.chineseName
              }
            }
          },
          onRowDataChanged: event => {
            // 清除单选行
            event.api.clearFocusedCell()
          },
          onCellFocused: async event => {
            const nodes = event.api.rowModel.rowsToDisplay
            const selectedNode = nodes[event.rowIndex]
            if (selectedNode) {
              const data = selectedNode.data
              if (data.type === 3) {
                if (!data.operationResponsibilities) {
                  this.loading = true
                  await getOperationResponsibilityKeys({ roleKey: data.uuid }).then(res => {
                    data.operationResponsibilities = this.ors.rowData.filter(p => res.data.includes(p.uuid))
                  }).finally(() => {
                    this.loading = false
                  })
                }
                this.ora.selectedRole = data
                this.ora.rowData = [...data.operationResponsibilities]
              }
            }
          },
          context: { componentParent: this }
        },
        columnDefs: [],
        rowData: [],
        gridApi: null
      },
      ora: { // 已经分配职责
        gridOptions: {
          rowSelection: 'single',
          suppressCellSelection: true, // 如果为true，则不能选择单元格。
          suppressRowClickSelection: true, // 如果为true，则单击行时不会发生行选择。
          onRowDataChanged: event => {
            // 清除单选行
            event.api.clearFocusedCell()
          },
          onCellFocused: event => {
            const nodes = event.api.rowModel.rowsToDisplay
            this.ora.selectedNode = nodes[event.rowIndex] || null
          },
          onSortChanged: event => {
            // 重置单选行
            if (this.ora.selectedNode) {
              const rowIndex = this.ora.selectedNode.rowIndex
              this.ora.selectedNode = null
              event.api.setFocusedCell(rowIndex, event.columnApi.getAllDisplayedColumns()[0])
            }
          },
          context: { componentParent: this }
        },
        columnDefs: [
          {
            headerName: this.$t('CargoMsg.Cargo_Name'),
            field: 'name'
          }, {
            headerName: this.$t('CargoMsg.Cargo_EnglishName'),
            field: 'englishName'
          }, {
            headerName: this.$t('CargoMsg.Cargo_Airline'),
            field: 'airRoute'
          }, {
            headerName: this.$t('CargoMsg.Cargo_AirlineCompany'),
            field: 'airCmp'
          }, {
            headerName: this.$t('SeaExport.BookingProperty'),
            field: 'bookingTerm'
          }, {
            headerName: this.$t('CargoMsg.Cargo_Airport'),
            field: 'airPort'
          }, {
            headerName: this.$t('CargoMsg.Cargo_Sales'),
            field: 'sales'
          }
        ],
        selectedRole: null,
        rowData: [],
        selectedNode: null,
        gridApi: null
      },
      ors: { // 职责列表
        gridOptions: {
          rowSelection: 'single',
          suppressCellSelection: true, // 如果为true，则不能选择单元格。
          suppressRowClickSelection: true, // 如果为true，则单击行时不会发生行选择。
          onRowDataChanged: event => {
            // 清除单选行
            event.api.clearFocusedCell()
          },
          onCellFocused: event => {
            const nodes = event.api.rowModel.rowsToDisplay
            this.ors.selectedNode = nodes[event.rowIndex] || null
          },
          onSortChanged: event => {
            // 重置单选行
            if (this.ors.selectedNode) {
              const rowIndex = this.ors.selectedNode.rowIndex
              this.ors.selectedNode = null
              event.api.setFocusedCell(rowIndex, event.columnApi.getAllDisplayedColumns()[0])
            }
          },
          context: { componentParent: this }
        },
        columnDefs: [
          {
            headerName: this.$t('CargoMsg.Cargo_Name'),
            field: 'name'
          }, {
            headerName: this.$t('CargoMsg.Cargo_EnglishName'),
            field: 'englishName'
          }, {
            headerName: this.$t('CargoMsg.Cargo_Airline'),
            field: 'airRoute'
          }, {
            headerName: this.$t('CargoMsg.Cargo_AirlineCompany'),
            field: 'airCmp'
          }, {
            headerName: this.$t('SeaExport.BookingProperty'),
            field: 'bookingTerm'
          }, {
            headerName: this.$t('CargoMsg.Cargo_Airport'),
            field: 'airPort'
          }, {
            headerName: this.$t('CargoMsg.Cargo_Sales'),
            field: 'sales'
          }
        ],
        rowData: [],
        selectedNode: null,
        gridApi: null
      }
    }
  },
  created() {
    this.loading = true
    Promise.all([
      getOfficeDeptTree(),
      loadSpecificBasicInfo('AirRoute'),
      loadAllOperationResponsibility()
    ]).then(results => {
      this.officeDeptTree.rowData = results[0].data
      for (const item of this.officeDeptTree.rowData) {
        if (item.type === 1) {
          item.officeCode = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office, 'uuid', item.officeUuid, 'code')
        } else {
          item.officeCode = ''
        }
        item.operationResponsibilities = ''
      }
      this.airRouteList = results[1].data
      this.ors.rowData = results[2].data
      for (const item of this.ors.rowData) {
        /* 航线 */
        let criteria = this.getCriteriaByType(item.operationResponsibilityCriteria, AIR_ROUTE)
        let airRoute = null
        if (criteria && criteria.criteriaValue) {
          airRoute = this.airRouteList.find(p => p.code === criteria.criteriaValue)
        }
        item.airRoute = airRoute ? airRoute.name : ''
        /* 航空公司 */
        criteria = this.getCriteriaByType(item.operationResponsibilityCriteria, AIR_COMPANY)
        if (criteria && criteria.criteriaValue) {
          item.airCmp = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(criteria.criteriaValue), 'chineseName')
        } else {
          item.airCmp = ''
        }
        /* 订舱性质 */
        criteria = this.getCriteriaByType(item.operationResponsibilityCriteria, BOOKING_TERM)
        if (criteria && criteria.criteriaValue) {
          item.bookingTerm = ColumnUtils.resolveColumnLabel(TYPE_NAMES.local_cache_BookingTerm, 'code', criteria.criteriaValue, 'chineseName')
        } else {
          item.bookingTerm = ''
        }
        /* 空港 */
        criteria = this.getCriteriaByType(item.operationResponsibilityCriteria, AIR_PORT)
        if (criteria && criteria.criteriaValue) {
          item.airPort = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Airport, 'code', criteria.criteriaValue, 'chineseName')
        } else {
          item.airPort = ''
        }
        /* 销售 */
        criteria = this.getCriteriaByType(item.operationResponsibilityCriteria, SALES)
        if (criteria && criteria.criteriaValue) {
          item.sales = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(criteria.criteriaValue), 'chineseName')
        } else {
          item.sales = ''
        }
      }
    }).finally(() => {
      this.loading = false
    })
  },
  methods: {
    getCriteriaByType(operationResponsibilityCriterias, type) {
      return operationResponsibilityCriterias.find(p => p.criteriaType === type) || null
    },
    add() {
      if (!this.ora.selectedRole) {
        return
      }
      const row = this.ors.selectedNode.data
      const index = this.ora.rowData.findIndex(p => p.uuid === row.uuid)
      if (index >= 0) {
        return
      }
      this.ora.rowData.push(row)
      if (this.ora.selectedNode) {
        const selectedKey = this.ora.selectedNode.data.uuid
        setTimeout(() => {
          const nodes = this.ora.gridApi.rowModel.rowsToDisplay
          const selectedNode = nodes.find(p => p.data.uuid === selectedKey)
          this.ora.gridApi.setFocusedCell(selectedNode.rowIndex, this.ora.gridApi.columnController.getAllDisplayedColumns()[0])
        }, 100)
      }
    },
    remove() {
      const row = this.ora.selectedNode.data
      const index = this.ora.rowData.findIndex(p => p.uuid === row.uuid)
      this.ora.rowData.splice(index, 1)
    },
    save() {
      if (this.ora.selectedRole) {
        const rawData = this.ora.selectedRole.operationResponsibilities
        const rowData = this.ora.rowData
        const deletedResponsibilityKeys = []
        const addedResponsibilityKeys = []
        for (const item of rawData) {
          const index = rowData.findIndex(p => p.uuid === item.uuid)
          if (index < 0) {
            deletedResponsibilityKeys.push(item.uuid)
          }
        }
        for (const item of rowData) {
          const index = rawData.findIndex(p => p.uuid === item.uuid)
          if (index < 0) {
            addedResponsibilityKeys.push(item.uuid)
          }
        }
        this.loading = true
        saveOperationResponsibilities({ roleKey: this.ora.selectedRole.uuid, deletedResponsibilityKeys, addedResponsibilityKeys }).then(res => {
          this.ora.selectedRole.operationResponsibilities = [...rowData]
          this.currentState = NORMAL
          this.$message.success(this.$t('Message.SaveSuccessfully'))
        }).finally(() => {
          this.loading = false
        })
      }
    },
    cancel() {
      this.currentState = NORMAL
      if (this.ora.selectedRole) {
        this.ora.rowData = [...this.ora.selectedRole.operationResponsibilities]
      } else {
        this.ora.rowData = []
      }
    }
  }
}
</script>

<style scoped lang="scss">
.shadow {
  z-index: 99;
  opacity: 0.6;
  pointer-events: none;
}
</style>
